import React from 'react';

const PaymentProcessingScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-900">Procesando pago</h2>
        <p className="text-sm text-gray-600 mt-2">Por favor espera un momento...</p>
      </div>
    </div>
  );
};

export default PaymentProcessingScreen;